import { gql } from 'apollo-boost';

// A small owner-scoped mutation records an intentional interaction without
// refetching content or temporary media URLs. Apollo merges the returned date.
export const RECORD_MESSAGE_VIEW = gql`
    mutation RecordMessageView($messageId: ID!) {
        recordMessageView(messageId: $messageId) {
            id
            lastViewedAt
        }
    }
`;

const pendingByClient = new WeakMap();

export const recordMessageView = (client, messageId) => {
    const id = String(messageId || '').trim();
    if (!client?.mutate || !/^[a-f\d]{24}$/i.test(id)) return Promise.resolve(null);
    let pending = pendingByClient.get(client);
    if (!pending) {
        pending = new Map();
        pendingByClient.set(client, pending);
    }
    if (pending.has(id)) return pending.get(id);
    const request = Promise.resolve().then(() => client.mutate({
        mutation: RECORD_MESSAGE_VIEW,
        variables: { messageId: id }
    })).then(result => result?.data?.recordMessageView || null)
        // A failed history write must never interrupt opening/playing content.
        .catch(() => null)
        .finally(() => pending.delete(id));
    pending.set(id, request);
    return request;
};
